import { addNotification } from "../actions/notificationActions"

import { configTemplateApi } from "../../api/configTemplateApi"

import { configTemplateSignal, configTemplateLoadedSignal, configTemplateErrorSignal, configTemplateListSignal, configTemplateListLoadedSignal, configTemplateListErrorSignal } from '../signals/configTemplateSignals.js'

export const fetchConfigTemplate = async (businessEntityId, configTemplateId, config, accessToken) => {
    configTemplateLoadedSignal.value = false
    configTemplateSignal.value = null
    return await configTemplateApi.fetchConfigTemplate(businessEntityId, configTemplateId, config, accessToken).then(
        (configTemplate) => {
            configTemplateSignal.value = configTemplate
            configTemplateLoadedSignal.value = true
            return configTemplateSignal.value
        }
    ).catch(
        (err) => {
            configTemplateErrorSignal.value = err
            addNotification(`Unable to load data - ${err}`)
        }
    )
}

export const fetchConfigTemplateList = async (businessEntityId, config, accessToken) => {
    configTemplateListLoadedSignal.value = false
    configTemplateListSignal.value = []
    return await configTemplateApi.fetchConfigTemplateList(businessEntityId, config, accessToken).then(
        (configTemplates) => {
            configTemplateListSignal.value = configTemplates
            configTemplateListLoadedSignal.value = true
            return configTemplateListSignal.value
        }
    ).catch(
        (err) => {
            configTemplateListErrorSignal.value = err
            console.log(err)
            addNotification(`Unable to load data due to the following error - ${err}`)
        }
    )
}

export const createConfigTemplate = async (businessEntityId, configTemplate, config, accessToken) => {
    configTemplateListLoadedSignal.value = false
    return await configTemplateApi.createConfigTemplate(businessEntityId, configTemplate, config, accessToken).then(
        async (configTemplate) => {
            return await fetchConfigTemplateList(businessEntityId, config, accessToken).then(
                () => {
                    return configTemplate
                }
            )
        }
    ).catch(
        (error) => {
            configTemplateListErrorSignal.value = error
            throw error
        }
    )
}

export const updateConfigTemplate = async (businessEntityId, configTemplate, config, accessToken) => {
    return await configTemplateApi.updateConfigTemplate(businessEntityId, configTemplate, config, accessToken)
}

export const deleteConfigTemplate = async (businessEntityId, configTemplateId, config, accessToken) => {
    configTemplateListLoadedSignal.value = false
    return await configTemplateApi.deleteConfigTemplate(businessEntityId, configTemplateId, config, accessToken).then(
        async (response) => {
            return await fetchConfigTemplateList(businessEntityId, config, accessToken).then(
                () => {
                    return response
                }
            )
        }
    ).catch(
        (error) => {
            configTemplateListErrorSignal.value = error
            throw error
        }
    )
}

export const applyConfigTemplate = async (businessEntityId, configTemplateId, componentId, config, accessToken) => {
    return await configTemplateApi.applyConfigTemplate(businessEntityId, configTemplateId, componentId, config, accessToken)
}